import fetchAPI from '../utils/fetchAPI';

export default ({ xsrfToken }: { xsrfToken: string }) =>
  fetchAPI({
    method: 'POST',
    url: `/smb-profile/api/onboard`,
    xsrfToken,
  });
